<script lang="ts" setup>
  import { useShared } from '@othercommerce/foundation';
  import { computed } from 'vue';

  interface Props {
    value?: string | number | null | undefined,
    code?: string | null | undefined,
    decimals?: number | null | undefined,
  }

  const props = defineProps<Props>();
  const shared = useShared();

  const numerical = computed(() => {
    return new Intl.NumberFormat(shared.value.appLocale, {
      style: 'currency',
      currency: props.code || shared.value.appCurrency,
      minimumFractionDigits: props.decimals ?? 2,
      maximumFractionDigits: props.decimals ?? 2,
    });
  });

  function formatNumber(value: string | number | null | undefined) {
    const numeric = Number(value);

    if (isNaN(numeric)) {
      throw new Error(`"${value}" cannot be cast to a numeric value.`);
    }

    return numerical.value.format(Math.abs(numeric) * -1);
  }
</script>

<template>
  {{ formatNumber(value) }}
</template>
